module.exports = __webpack_public_path__ + "static/media/img-15.590e00cd.jpg";